var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"private-order"},[_c('div',{staticClass:"private-order-layout px-0 py-0"},[_c('private-order-banner'),_c('private-order-catalog')],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }